import { Box } from "@mui/system";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/modal/Modal";
import StatusCard from "../../components/status-card/StatusCard";
import Table from "../../components/table/Table";
import { fetchAllBrokers } from "../../redux/features/broker.features";
import customerFeatures, { fetchAllCustomers } from "../../redux/features/customer.features";
import { fetchAllProduct } from "../../redux/features/product.features";
import { fetchAllSales } from "../../redux/features/sales.features";
import { fetchAllSuppliers } from "../../redux/features/suppliers.features";
import PrintAllCustomersAddress from "./PrintAllCustomersAddress";
import PrintAllItemsReport from "./PrintAllItemsReport";
import PrintAllSoldItems from "./PrintAllSoldItems";
import PrintAvailableItem from "./PrintAvailableItem";
import PrintExportCategoryList from "./PrintExportCategoryList";
import "./Report.css";
const StockReport = () => {
  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllCustomers());
    dispatch(fetchAllBrokers());
    dispatch(fetchAllProduct());
    dispatch(fetchAllSuppliers());
    dispatch(fetchAllSales());
  }, [dispatch]);

  let productState = useSelector((state) => {
    return state.productReducer;
  });

  let { products } = productState;

  let salesState = useSelector((state) => {
    return state.salesReducer;
  });
  let { recentInvoice, invoice, sales, successMessage, errorMessage } =
    salesState;

    useEffect(() => {
      dispatch(fetchAllCustomers());
    }, [dispatch]);
  
    let customerState = useSelector((state) => {
      return state.customerReducer;
    });
  
    let { customers , loading } = customerState;



  let printAllItemsReportRef = useRef();

  const Row = (props) => (
    <div className="flex w-full flex-col">
      <p className="p-2 font-extrabold text-2xl text-white">{props.header}</p>
      <hr></hr>
      <div className="flex flex-wrap p-5">{props.children}</div>
    </div>
  );

  const [showAllItemsModal, setShowAllItemsModal] = useState(false);
  const [showExportCategoryPrintModal, setShowExportCategoryPrintModal] = useState(false);
  const [showBusinessAddressPrintModal, setShowBusinessAddressPrintModal] = useState(false);
  const [
    showAvailableItemsForForeignModal,
    setShowAvailableItemsForForeignModal,
  ] = useState(false);
  const [showAllSoldItemModal, setShowAllSoldItemModal] = useState(false);
  const [countOfThisMonthSold, setcountOfThisMonthSold] = useState(0);

  useEffect(() => {
    let thismonthitemssoldcount = 0;
    let thisMonthSales = sales.filter(
      (x) => {
        
        // console.log("moment(x.invoiceCreatedDate).month === moment().month",moment(x.invoiceCreatedDate).month() === moment().month()+1)
        console.log("moment(x.invoiceCreatedDate).month ",moment(x.invoiceCreatedDate).format('MMMM') , moment(x.invoiceCreatedDate).month()+1  )
        console.log("current month", moment().format('MMMM') , moment().month()+1)
        return moment(x.invoiceCreatedDate).format('MMMM') === moment().format('MMMM')
      }
    );
    thisMonthSales.map((x) => {
      thismonthitemssoldcount += x.invoiceItemList.length;
    });

    setcountOfThisMonthSold(thismonthitemssoldcount);
  }, [sales]);

  return (
    <div className="flex">
      <Row header={"Items Reports"}>
        <StatusCard
          style={{ margin: 16, minWidth: 300 }}
          onClick={() => {
            setShowAllItemsModal(true);
          }}
          icon={"bx bx-package"}
          count={products.length}
          title={"All Items List"}
        ></StatusCard>
        <StatusCard
          onClick={() => setShowAllSoldItemModal(true)}
          style={{ margin: 16, minWidth: 300 }}
          icon={"bx bx-package"}
          count={products.filter((x) => x.isSold).length}
          title={"All Sold Items List"}
        ></StatusCard>
        <StatusCard
          style={{ margin: 16, minWidth: 300 }}
          icon={"bx bx-package"}
          count={products.filter((x) => !x.isSold).length}
          title={"All Available Items List"}
        ></StatusCard>
        <StatusCard
          style={{ margin: 16, minWidth: 300 }}
          icon={"bx bx-package"}
          count={products.filter(x => moment(x.date).format('MMMM') === moment().format('MMMM')).length}
          title={"This month purchase"}
        ></StatusCard>
        <StatusCard
          style={{ margin: 16, minWidth: 300 }}
          icon={"bx bx-package"}
          count={countOfThisMonthSold}
          title={"This month sold"}
        ></StatusCard>
        <StatusCard
          style={{ margin: 16, minWidth: 300 }}
          icon={"bx bx-package"}
          count={
            sales.filter(
              (x) =>  moment(x.invoiceCreatedDate).format('MMMM') === moment().format('MMMM')
            ).length
          }
          title={"This month invoice"}
        ></StatusCard>
        <StatusCard
          onClick={() => {
            setShowAvailableItemsForForeignModal(true);
          }}
          style={{ margin: 16, minWidth: 300 }}
          icon={"bx bx-package"}
          count={products.filter((x) => !x.isSold).length}
          title={"STOCK TAKING OUT LIST"}
        ></StatusCard>
        <StatusCard
          onClick={() => {
            setShowBusinessAddressPrintModal(true)
          }}
          style={{ margin: 16, minWidth: 300 }}
          icon={"bx bx-user"}
          count={customers.length}
          title={"CUSTOMER BUSINESS ADDRESS LABEL PRINT"}
        ></StatusCard>
        <StatusCard
          onClick={() => {
            setShowExportCategoryPrintModal(true)
          }}
          style={{ margin: 16, minWidth: 300 }}
          icon={"bx bx-package"}
          count={products.filter((x) => !x.isSold).length}

          title={"EXPORT CATEGORY LIST WISE PRINT"}
        ></StatusCard>






        <Modal
          modal_title={"All Items List"}
          canShow={showAllItemsModal}
          updateModalState={() => setShowAllItemsModal((state) => !state)}
        >
          <Box>
            <PrintAllItemsReport
              onClose={() => setShowAllItemsModal((state) => !state)}
            />
          </Box>
        </Modal>


        <Modal
          modal_title={"All Items List"}
          canShow={showAvailableItemsForForeignModal}
          updateModalState={() =>
            setShowAvailableItemsForForeignModal((state) => !state)
          }
        >
          <Box>
            <PrintAvailableItem
              onClose={() =>
                setShowAvailableItemsForForeignModal((state) => !state)
              }
            />
          </Box>
        </Modal>
        <Modal
          modal_title={"All Sold Items List"}
          canShow={showAllSoldItemModal}
          updateModalState={() => setShowAllSoldItemModal((state) => !state)}
        >
          <Box>
            <PrintAllSoldItems
              onClose={() => setShowAllSoldItemModal((state) => !state)}
            />
          </Box>
        </Modal>
      </Row>


{/* customer model */}
<Modal
          modal_title={"Export category"}
          canShow={showExportCategoryPrintModal}
          updateModalState={() =>
            setShowExportCategoryPrintModal((state) => !state)
          }
        >
          <Box>
            <PrintExportCategoryList
              onClose={() =>
                setShowExportCategoryPrintModal((state) => !state)
              }
            />
          </Box>
        </Modal>
{/* customer model */}
<Modal
          modal_title={"All Customers List"}
          canShow={showBusinessAddressPrintModal}
          updateModalState={() =>
            setShowBusinessAddressPrintModal((state) => !state)
          }
        >
          <Box>
            <PrintAllCustomersAddress
              onClose={() =>
                setShowAvailableItemsForForeignModal((state) => !state)
              }
            />
          </Box>
        </Modal>


    </div>
  );
};

export default StockReport;
